import { createIcon } from '../createIcon';
import { ReactComponent as IconDoorOpen } from '../svg/door-open.svg';

export default createIcon(IconDoorOpen);
